// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4diHg","content":"styles_content__2zv-1"};